<template>
  <v-container
    id="blog"
    class="pt-12 pb-0 px-0"
    fluid
    tag="section"
  >
    <headline />

    <v-responsive
      class="mx-auto"
      max-width="1280"
    >
      <v-container>
        <v-row>
          <v-col
            v-for="(service, i) in services"
            :key="i"
            class="d-flex"
            cols="12"
            md="6"
          >
            <post-card :post="service" />
          </v-col>
        </v-row>
      </v-container>
    </v-responsive>
  </v-container>
</template>

<script>
  export default {
    name: 'Services',

    components: {
      PostCard: () => import('./components/PostCard'),
      Headline: () => import('./components/Headline'),
    },

    data: () => ({
      services: [
        {
          hours: 'минимум 3 часа',
          week: '4',
          scorephoto: '200',
          scorephotoend: '800',
          scoreretush: '50',
          scoreretushend: '100',
          dateone: '2',
          datetwo: '6',
          category: 'https://vk.com/@dariashakalowaphoto-svadebnayafotosemka',
          date: '2500 руб./час',
          src: 'others/luke-matthews-4FTlby-DERs-unsplash.jpg',
          title: 'Свадебная фотосессия',
        },
        {
          hours: '1 час',
          week: '2',
          scorephoto: '100',
          scorephotoend: '150',
          scoreretush: '20',
          scoreretushend: '30',
          dateone: '1',
          datetwo: '3',
          category: 'https://vk.com/album-168514331_271725346',
          date: '2500 руб./час',
          src: 'others/luke-matthews-6D1eGsCruvg-unsplash.jpg',
          title: 'Семейная фотосессия',
        },
        {
          hours: '1 час',
          week: '2',
          scorephoto: '100',
          scorephotoend: '150',
          scoreretush: '20',
          scoreretushend: '30',
          dateone: '1',
          datetwo: '3',
          category: 'https://vk.com/@dariashakalowaphoto-fotosemka-love-story',
          date: '2300 руб./час',
          src: 'others/luke-matthews-Af_8NfhyX8A-unsplash.jpg',
          title: 'Love-story',
        },
        {
          hours: '1 час',
          week: '2',
          scorephoto: '100',
          scorephotoend: '150',
          scoreretush: '20',
          scoreretushend: '30',
          dateone: '1',
          datetwo: '3',
          category: 'https://vk.com/@dariashakalowaphoto-personalnaya-fotosemk',
          date: '2000 руб./час',
          src: 'others/luke-matthews-T4PTfNwgbEM-unsplash.jpg',
          title: 'Индивидуальное фото',
        },
      ],
      tabs: [
        'All',
        'Nature',
        'Cities',
        'Branding',
        'Design',
      ],
    }),
  }
</script>
